export default __webpack_public_path__ + "static/media/home-travel-agency-tour-intrest-img02.7ee7891b.jpg";